"use strict";
// ---------------------------------------------------------------------------
// InfoBanner configuration — the ONE place to tune everything.
//
// The InfoBanner surfaces a HabitatMap blog post on the map, occasionally and
// non-intrusively. Adjust the numbers below to change how often it appears and
// edit BLOG_POSTS to change what it links to. No other file needs touching.
// ---------------------------------------------------------------------------
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOG_POSTS = exports.LINK_REF = exports.BANNER_CAMPAIGN = exports.BANNER_SOURCE = exports.AB_SPLIT_MINIMAL = exports.STORAGE_KEYS = exports.CLICKED_DAYS = exports.DISMISS_DAYS = exports.COOLDOWN_DAYS = exports.SHOW_PROBABILITY = void 0;
/**
 * Chance (0–1) that the banner is eligible to appear on any given page load,
 * assuming no cooldown/dismiss/click suppression is active. Lower = rarer.
 * Set to 1 = always eligible (suppression windows still apply).
 */
exports.SHOW_PROBABILITY = 1;
/**
 * After the banner is shown, don't show it again for this many days
 * (even across page loads where the probability roll would pass).
 */
exports.COOLDOWN_DAYS = 1;
/** After the user closes (✕) the banner, suppress it for this many days. */
exports.DISMISS_DAYS = 5;
/** After the user clicks through to an article, suppress it for this many days. */
exports.CLICKED_DAYS = 1;
/** localStorage keys — namespaced to avoid clashes with other features. */
exports.STORAGE_KEYS = {
    lastShown: "ac_blog_last_shown",
    dismissedAt: "ac_blog_dismissed_at",
    clickedAt: "ac_blog_clicked_at",
    lastPostSlug: "ac_blog_last_post_slug",
};
/** Probability (0–1) that any given show uses the "minimal" variant. */
exports.AB_SPLIT_MINIMAL = 0.5;
// ---------------------------------------------------------------------------
// Shared analytics schema — MUST stay identical to HabitatMap.
// Source of truth: HabitatMap/docs/analytics-tracking.md §1.3.
// This banner is Test A: banner_source "aircasting", banner_campaign "blog_promo".
// ---------------------------------------------------------------------------
/** `banner_source` — which property shows the banner. */
exports.BANNER_SOURCE = "aircasting";
/** `banner_campaign` — the experiment id (Test A). */
exports.BANNER_CAMPAIGN = "blog_promo";
/**
 * Attribution params appended to the outbound blog link so HabitatMap's GTM /
 * GA4 can trace the visit (and any resulting AirBeam purchase) back to the
 * banner. `utm_content` carries the variant and `ac_post` the post slug (= the
 * HM post's URL slug). See HabitatMap/docs/analytics-tracking.md §3.3.
 */
exports.LINK_REF = {
    utmSource: exports.BANNER_SOURCE,
    utmMedium: "info_banner",
    utmCampaign: exports.BANNER_CAMPAIGN,
};
// How the image URLs below were found: each HabitatMap blog post exposes its
// hero image in the page's <meta property="og:image"> tag. Grab it with:
//   curl -sL <post-url> | grep -oiE '<meta property="og:image"[^>]*content="[^"]*"'
// The `?nf_resize=smartcrop&w=680&h=280` suffix is HabitatMap's (Netlify) image
// CDN resizing it to a banner-sized crop so we don't pull the full-res original.
//
// Prefer to bundle assets instead of hotlinking? Download each image into
// assets/images/blog/, import it here, and set `image` to the import.
const CDN_CROP = "?nf_resize=smartcrop&w=680&h=280";
/**
 * Hardcoded list of posts. Keep it to ~3–5. One is chosen at random on each
 * real show (never repeating the previous one).
 */
exports.BLOG_POSTS = [
    {
        postSlug: "what-do-those-colored-circles-mean-understanding-air-quality-on-the-aircasting-map",
        url: "https://www.habitatmap.org/blog/what-do-those-colored-circles-mean-understanding-air-quality-on-the-aircasting-map",
        title: "What do those colored dots mean? Understanding the Air Quality Index",
        image: `https://www.habitatmap.org/images/uploads/aircastingmapdots.png${CDN_CROP}`,
    },
    {
        postSlug: "when-fresh-scents-turn-toxic-how-candles-and-incense-impact-your-health",
        url: "https://www.habitatmap.org/blog/when-fresh-scents-turn-toxic-how-candles-and-incense-impact-your-health",
        title: "When fresh scents turn toxic: how candles and incense impact your health",
        image: `https://www.habitatmap.org/images/uploads/burning-candles-zz-230419-5dd288.avif${CDN_CROP}`,
    },
    {
        postSlug: "nyc-community-organizations-use-aircasting-to-study-hyperlocal-air-quality-1",
        url: "https://www.habitatmap.org/blog/nyc-community-organizations-use-aircasting-to-study-hyperlocal-air-quality-1",
        title: "NYC Community Organizations Use AirCasting to Study Hyperlocal Air Quality",
        image: `https://www.habitatmap.org/images/uploads/williamsburghexagonmap.png${CDN_CROP}`,
    },
];
